import styled from 'styled-components'

export const Body = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['12'],
}))
